import { render, staticRenderFns } from "./VCheckbox.vue?vue&type=template&id=d0946d8c&"
import script from "./VCheckbox.vue?vue&type=script&lang=js&"
export * from "./VCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports